import * as angular from "angular";
import {IController} from "angular";
import * as PhoneFormat from "phoneformat.js";
import {SitesRequestsService} from "../../../sites/services/sites-requests.service";
import {SplitService} from "../../services/split-service.service";

export class PhoneNumberCtrl implements IController {

  phone: any;
  fieldName: string;
  noIcon: any;
  required: boolean;
  ngDisabled: boolean;
  label: boolean;
  form: any;
  onChange: Function

  public model: any;
  private country: any;
  private siteId: any;

  constructor(private splitService: SplitService, private sitesRequestsService: SitesRequestsService) {
  }

  $onInit() {
    this.country = this.splitService.getCountryCode();
    this.siteId = this.splitService.getSiteId();


    if (!this.fieldName) {
      this.fieldName = 'phone'
    }

    if (!!this.phone) {
      const formatted = PhoneFormat.formatLocal(this.country, this.phone);
      this.model = PhoneFormat.cleanPhone(formatted);
    } else {
      this.model = undefined;
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.phone && !changes.phone.isFirstChange()) {
      this.$onInit();
    }
  }

  phoneChanged() {
    if (this.model) {
      this.sitesRequestsService.validatePhoneNumber(this.siteId, this.model, this.country)
        .then((res) => {
          if (res.isValid) {
            const formatted = PhoneFormat.formatE164(this.country, this.model); //+972
            this.onChange({phone: formatted});
          }
          this.form[this.fieldName].$setValidity('valid', res.isValid);
        })
        .catch((error) => {
          this.form[this.fieldName].$setValidity('valid', false);
        })
    } else {
      this.form[this.fieldName].$setValidity('valid', true);
      this.onChange({phone: undefined});
    }
  }

}

angular
  .module('bringoz.admin.commons')
  .component('phoneNumber', {
    require: {
      form: '^form'
    },
    bindings: {
      phone: '<',
      fieldName: '@?',
      noIcon: '@',
      required: '@?',
      onChange: '&',
      ngDisabled: '<?',
      label: '<?'
    },
    template: require('./phone-number.html').default,
    controller: PhoneNumberCtrl
  });
